module.exports = __webpack_public_path__ + "img/9788946049208.d09355c8.jpg";